var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233.084,
    height: 31.762,
    viewBox: "0 0 233.084 31.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(-138 -29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M19.8,65.64l6.479-6.623a1.554,1.554,0,0,1,1.131-.419l2.912,0c.757,0,1.375-.435,1.376-.97l0-2.916c0-.535-.616-.972-1.373-.973l-6.517-.008a1.546,1.546,0,0,0-1.13.419l-7.341,7.5-7.211,7.37a.739.739,0,0,0,0,1.1l7.194,7.388,7.322,7.521a1.546,1.546,0,0,0,1.13.421l7.891.01,3.435,0,3.434,0,2.061,0c.757,0,1.375-.435,1.375-.97l.005-3.887.01-8.575.006-4.859.009-7.6c0-.535.619-.971,1.376-.97l2.06,0,4.286.005a1.55,1.55,0,0,1,1.13.422l6.464,6.639a.728.728,0,0,1,.085,1,1.493,1.493,0,0,1-1.217.518L46.795,67.2c-.757,0-1.375.436-1.376.971l0,2.915c0,.536.616.972,1.373.973l9.383.012a1.49,1.49,0,0,1,1.217.522.728.728,0,0,1-.088,1l-6.479,6.623a1.554,1.554,0,0,1-1.131.418l-2.912,0c-.757,0-1.375.434-1.376.97l0,2.915c0,.535.616.972,1.373.973l6.517.008a1.55,1.55,0,0,0,1.131-.418l7.34-7.5,7.212-7.371a.74.74,0,0,0,0-1.1L61.78,61.713l-7.322-7.521a1.55,1.55,0,0,0-1.13-.421l-7.891-.01-3.434,0-3.435,0-2.062,0c-.756,0-1.374.435-1.374.971l-.005,3.887-.01,8.574-.006,4.859-.009,7.6c0,.535-.619.971-1.375.97l-2.061,0-4.286,0a1.55,1.55,0,0,1-1.13-.421l-6.464-6.639a.728.728,0,0,1-.085-1,1.489,1.489,0,0,1,1.218-.519l9.383.011c.757,0,1.375-.434,1.375-.97l0-2.915c0-.535-.616-.973-1.373-.974l-9.384-.011a1.492,1.492,0,0,1-1.216-.521.728.728,0,0,1,.088-1",
    transform: "translate(130.124 -24.735)",
    fill: "#273a4e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M93,79.16a12.185,12.185,0,0,1-4.633,4.268,12.486,12.486,0,0,1-5.545,1.255,10.89,10.89,0,0,1-4.382-.89,11.193,11.193,0,0,1-5.957-5.956,10.91,10.91,0,0,1-.89-4.382,11.026,11.026,0,0,1,.89-4.428,11.681,11.681,0,0,1,2.4-3.583,11.185,11.185,0,0,1,3.56-2.419,10.907,10.907,0,0,1,4.382-.89,12.646,12.646,0,0,1,5.682,1.347,12.187,12.187,0,0,1,4.77,4.587l-12.1,10.726a3.988,3.988,0,0,0,1.324.319,4.773,4.773,0,0,0,1.735-.136,8.377,8.377,0,0,0,2.693-1.255,9.05,9.05,0,0,0,2.236-2.26ZM77.03,72.588a4.91,4.91,0,0,0,.023,2.168,3.153,3.153,0,0,0,.753,1.483l8.033-7.577a5.058,5.058,0,0,0-3.788-1.05,5.786,5.786,0,0,0-3.332,1.552,6,6,0,0,0-1.689,3.424",
    transform: "translate(130.124 -24.735)",
    fill: "#fa6400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M94.776,79.522l4.81-4.716a7.3,7.3,0,0,0,6.072,2.951c1.69,0,3.343-.611,3.343-1.837,0-1.542-3.064-2.9-6-4.2-3.789-1.634-7.039-4.122-7.039-8.635,0-5.181,4.921-8.876,10.6-8.876,4.568,0,8.133,2.154,9.3,5.106l-4.586,4.42c-.892-1.578-3.2-2.265-4.624-2.265-1.635,0-2.8.835-2.8,1.856,0,1.374,2.117,1.82,5.348,3.176,4.679,1.969,7.78,4.829,7.78,9.248,0,5.7-5.311,9.248-11.309,9.248-4.921,0-9.4-2.172-10.9-5.479",
    transform: "translate(130.124 -24.735)",
    fill: "#fa6400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 7.948,
    height: 29.935,
    transform: "translate(249.229 29.922)",
    fill: "#fa6400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M161.683,54.378V84.591h-7.948V72.725L145.676,84.09h-.055l-8.079-11.365V84.591h-7.948V54.378h3.194l12.851,17.6,12.85-17.6Z",
    transform: "translate(130.124 -24.735)",
    fill: "#fa6400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M183.63,77.407v7.465H164.224V54.937h7.948v22.47Z",
    transform: "translate(130.124 -24.735)",
    fill: "#273a4e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 7.948,
    height: 29.935,
    transform: "translate(315.995 29.922)",
    fill: "#273a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M195.939,79.522l4.81-4.716a7.3,7.3,0,0,0,6.072,2.951c1.689,0,3.343-.611,3.343-1.837,0-1.542-3.065-2.9-6-4.2-3.789-1.634-7.039-4.122-7.039-8.635,0-5.181,4.921-8.876,10.6-8.876,4.568,0,8.134,2.154,9.3,5.106l-4.587,4.42c-.892-1.578-3.195-2.265-4.624-2.265-1.635,0-2.8.835-2.8,1.856,0,1.374,2.116,1.82,5.348,3.176,4.679,1.969,7.781,4.829,7.781,9.248,0,5.7-5.312,9.248-11.31,9.248-4.921,0-9.4-2.172-10.9-5.479",
    transform: "translate(130.124 -24.735)",
    fill: "#273a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M240.961,62.085h-7.168V84.592h-7.966V62.085h-7.186V54.657h22.32Z",
    transform: "translate(130.124 -24.735)",
    fill: "#273a4e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aa5c0244bf477df988df9f052b3fbaa9.svg";
export { ForwardRef as ReactComponent };